import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { useFFContext } from '@/components/OpenFeature/hooks/useFFContext';
import { BusinessDocumentSearch } from '@/features/business_documents/List/Search/Search';
import { BusinessDocumentTableView } from '@/features/business_documents/List/Table';
import {
  useBusinessDocumentFormInitial,
  useBusinessDocumentSearchQuery,
} from '@/features/business_documents/List/hooks';
import { OpenFeatureProvider } from '@moneyforward/user-flex-feature-hooks';
import { memo } from 'react';

export const BusinessDocumentTableList = memo(() => {
  const defaultValues = useBusinessDocumentFormInitial();
  const { searchQuery, handleSearch } =
    useBusinessDocumentSearchQuery(defaultValues);

  const context = useFFContext();

  return (
    <Wrapper isProto={false}>
      <OpenFeatureProvider
        pollInterval={-1}
        context={context}
        domain='ap-frontend-export-business-document-list'
      >
        <BusinessDocumentSearch
          defaultValues={defaultValues}
          onSearch={handleSearch}
        />
        <BusinessDocumentTableView
          searchQuery={searchQuery}
          onSearch={handleSearch}
        />
      </OpenFeatureProvider>
    </Wrapper>
  );
});
BusinessDocumentTableList.displayName = 'BusinessDocumentTableList';
